module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/cz/name/suffix.js
// module id = 1505
// module chunks = 0